<div class="modal-header card-header">
    <div class="col-md-8 col-xs-8">
        <span class="text-blue text-125">Registro Historia</span>
        <span class="autoguardado-estado" *ngIf="estado_guardado" [ngClass]="'ag-'+estado_guardado">
            <ng-container *ngIf="estado_guardado=='guardando'"><i class="fas fa-sync fa-spin"></i> Guardando…</ng-container>
            <ng-container *ngIf="estado_guardado=='guardado'"><i class="fas fa-check-circle"></i> Guardado automáticamente {{fecha_guardado | date:'HH:mm:ss'}}</ng-container>
            <ng-container *ngIf="estado_guardado=='error'"><i class="fas fa-exclamation-triangle"></i> Error al guardar, se reintentará</ng-container>
        </span>
        <ng-container *ngIf="estado_edicion">
            <span class="plazo-edicion plazo-cerrada" *ngIf="historia_cerrada">
                <i class="fas fa-lock"></i> Historia cerrada el {{estado_edicion.editable_hasta | date:'dd/MM/yyyy HH:mm'}} · solo lectura
            </span>
            <span class="plazo-edicion" *ngIf="!historia_cerrada && estado_edicion.editable_hasta"
                  [class.plazo-por-vencer]="milisegundosRestantes() < 3600000">
                <i class="far fa-clock"></i> Editable hasta {{estado_edicion.editable_hasta | date:'dd/MM HH:mm'}} · quedan {{textoTiempoRestante()}}
            </span>
            <span class="plazo-edicion plazo-sin-iniciar" *ngIf="!historia_cerrada && !estado_edicion.editable_hasta && aplicacion_pacientes.puede_modificar">
                <i class="far fa-clock"></i> Editable {{estado_edicion.horas_edicion}} h desde el primer guardado
            </span>
        </ng-container>
    </div>
    <div class="col-md-4 col-xs-4">
        <button (click)="guardarReceta()" *ngIf="puedeEditar()" class="btn btn-primary">
        <i class="fa fa-save text-110 mr-1"></i>
        </button>&nbsp;
        <button class="btn btn-success" (click)="generarPdfReceta()" title="PDF historia completa">
            <i class="fas fa-file-pdf text-105"></i>
        </button>&nbsp;
        <button class="btn btn-info" (click)="generarPdfRecetaPreimpresa()" title="Recetario A5 (membrete preimpreso)">
            <i class="fas fa-prescription text-105"></i>
        </button>&nbsp;
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
        <i class="fa fa-times red2 text-110 mr-1"></i>
        </button>
    </div>
</div>
<div class="modal-body card-body receta-body">
  <div class="receta-layout">

    <!-- ===== Columna principal: Registro ===== -->
    <div class="receta-col-main">

    <!-- Datos del paciente -->
    <div class="paciente-info" *ngIf="paciente && paciente.cliente && paciente.cliente.persona">
        <div class="pi-avatar"><i class="fas fa-user-injured"></i></div>
        <div class="pi-datos">
            <div class="pi-nombre">
                {{paciente.cliente.persona.nombres}}
                {{paciente.cliente.persona.apellido_paterno}}
                {{paciente.cliente.persona.apellido_materno}}
            </div>
            <div class="pi-meta">
                <span *ngIf="paciente.cliente.identificacion"><i class="fas fa-hashtag"></i> {{paciente.cliente.identificacion}}</span>
                <span *ngIf="paciente.cliente.persona.genero"><i class="fas fa-venus-mars"></i> {{paciente.cliente.persona.genero.nombre}}</span>
                <span *ngIf="edadPaciente()!=null"><i class="fas fa-birthday-cake"></i> {{edadPaciente()}} años</span>
                <span *ngIf="paciente.cliente.persona.fecha_nacimiento"><i class="fas fa-calendar-day"></i> {{paciente.cliente.persona.fecha_nacimiento | date:'dd/MM/yyyy'}}</span>
                <span *ngIf="paciente.cliente.persona.ci"><i class="fas fa-id-card"></i> CI: {{paciente.cliente.persona.ci}}</span>
                <span *ngIf="paciente.cliente.persona.telefono_movil || paciente.cliente.persona.telefono"><i class="fas fa-phone"></i> {{paciente.cliente.persona.telefono_movil || paciente.cliente.persona.telefono}}</span>
            </div>
            <div class="pi-medico" *ngIf="especialidad_especialista && especialidad_especialista.especialidad">
                <i class="fas fa-user-md"></i>
                {{especialidad_especialista.especialidad.nombre}}
                <span *ngIf="especialidad_especialista.especialista">· {{especialidad_especialista.especialista.persona.nombre_completo}}</span>
            </div>
        </div>
    </div>

    <!-- Diagnóstico / Enfermedad -->
    <div class="receta-seccion">
        <label class="receta-titulo"><i class="fas fa-notes-medical"></i> Diagnóstico / Enfermedad</label>
        <div class="card bcard border-1 brc-dark-l1 receta-diag">
            <div class="card-body p-0">
                <form method="post">
                    <textarea id="summernote" name="editordata" [(ngModel)]="historia_paciente.descripcion" placeholder="Descripción">{{historia_paciente.descripcion}}</textarea>
                </form>
            </div>
        </div>
    </div>

    <!-- Medicamentos -->
    <div class="receta-seccion receta-seccion-med">
        <label class="receta-titulo"><i class="fas fa-pills"></i> Medicamentos</label>

        <div class="receta-alta" *ngIf="!historia_cerrada">
            <div class="row align-items-end">
                <div class="col-md-3 col-6">
                    <label class="receta-label">Medicamento</label>
                    <input type="text" class="form-control" [(ngModel)]="receta.medicamento" placeholder="Medicamento"/>
                </div>
                <div class="col-md-3 col-6">
                    <label class="receta-label">Presentación</label>
                    <input type="text" class="form-control" [(ngModel)]="receta.presentacion" placeholder="Presentación"/>
                </div>
                <div class="col-md-2 col-4">
                    <label class="receta-label">Cantidad</label>
                    <input type="number" class="form-control" [(ngModel)]="receta.cantidad" placeholder="Cantidad"/>
                </div>
                <div class="col-md-3 col-6">
                    <label class="receta-label">Indicación</label>
                    <input type="text" class="form-control" [(ngModel)]="receta.indicacion" placeholder="Indicación"/>
                </div>
                <div class="col-md-1 col-2 receta-alta-btn">
                    <button (click)="agregarReceta(receta)" class="btn btn-primary w-100" title="Agregar medicamento">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="table-responsive receta-tabla">
            <table class="table table-striped table-bordered table-hover mb-0">
                <thead class="thead-light">
                    <tr>
                        <th class="text-center" style="width:44px">Nº</th>
                        <th>Medicamento</th>
                        <th>Presentación</th>
                        <th class="text-center" style="width:90px">Cantidad</th>
                        <th>Indicación</th>
                        <th class="text-center" style="width:56px" *ngIf="!historia_cerrada"><i class="fa fa-cog text-secondary-d1"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let receta of historia_paciente.recetas; let i=index;">
                        <tr *ngIf="!receta.eliminado">
                            <td class="text-center">{{i+1}}</td>
                            <td>{{receta.medicamento}}</td>
                            <td>{{receta.presentacion}}</td>
                            <td class="text-center">{{receta.cantidad}}</td>
                            <td>{{receta.indicacion}}</td>
                            <td class="text-center" *ngIf="!historia_cerrada">
                                <a class="btn btn-sm btn-outline-danger" href="javascript:void(0)" (click)="eliminarReceta(receta)" title="Eliminar">
                                    <i class="fa fa-trash-alt"></i>
                                </a>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="!historia_paciente.recetas || historia_paciente.recetas.length===0">
                        <td [attr.colspan]="historia_cerrada?5:6" class="text-center text-muted py-3">Sin medicamentos agregados.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    </div><!-- /receta-col-main -->

    <!-- ===== Columna derecha: Historial (Kardex) ===== -->
    <div class="receta-col-kardex">
        <div class="kardex-panel">
            <div class="kardex-head">
                <span class="kardex-title"><i class="fas fa-notes-medical"></i> Historial del paciente</span>
                <div class="kardex-filtro">
                    <div class="input-group input-group-sm kf-in">
                        <input class="form-control" placeholder="Desde" name="kfi_dp" [(ngModel)]="filter.fecha_inicio" ngbDatepicker #kfi="ngbDatepicker">
                        <div class="input-group-append"><button class="btn btn-outline-secondary" type="button" (click)="kfi.toggle()"><i class="far fa-calendar"></i></button></div>
                    </div>
                    <div class="input-group input-group-sm kf-in">
                        <input class="form-control" placeholder="Hasta" name="kff_dp" [(ngModel)]="filter.fecha_fin" ngbDatepicker #kff="ngbDatepicker">
                        <div class="input-group-append"><button class="btn btn-outline-secondary" type="button" (click)="kff.toggle()"><i class="far fa-calendar"></i></button></div>
                    </div>
                    <button class="btn btn-sm btn-primary kf-buscar" type="button" (click)="buscarHistorialPaciente()"><i class="fa fa-search"></i></button>
                </div>
            </div>

            <div class="kardex-lista">
                <div class="kardex-empty" *ngIf="!historias_paciente || historias_paciente.length===0">
                    <i class="far fa-folder-open"></i> Sin historial en el rango.
                </div>
                <div class="kardex-item" *ngFor="let h of historias_paciente; let i=index;">
                    <div class="kardex-item-top">
                        <span class="kardex-fecha">{{h.fecha_hora | date:'dd/MM/yyyy · HH:mm'}}</span>
                        <i class="fas fa-lock kardex-cerrada" *ngIf="h.cerrada" title="Historia cerrada · solo lectura"></i>
                        <span class="kardex-tipo" *ngIf="h.tipo_cita">{{h.tipo_cita}}</span>
                    </div>
                    <div class="kardex-servicio" *ngIf="h.nombre">{{h.nombre}}</div>
                    <div class="kardex-obs" *ngIf="h.observacion"><i class="far fa-comment-dots"></i> {{h.observacion}}</div>
                    <div class="kardex-hc" *ngIf="h.descripcion">
                        <div class="kardex-hc-label"><i class="fas fa-notes-medical"></i> Historia clínica</div>
                        <div class="kardex-hc-cont" [innerHTML]="h.descripcion"></div>
                    </div>
                    <div class="kardex-meds-toggle" (click)="verMedicamentosHistoria(h)">
                        <i class="fas fa-pills"></i> Medicamentos
                        <i class="fa" [ngClass]="h.mostrar_medicamentos?'fa-chevron-up':'fa-chevron-down'"></i>
                    </div>
                    <div class="kardex-meds" *ngIf="h.mostrar_medicamentos">
                        <div class="kardex-meds-msg" *ngIf="h.cargando_medicamentos">Cargando…</div>
                        <div class="kardex-med" *ngFor="let m of h.medicamentos">
                            <span class="km-nombre">{{m.medicamento}}</span>
                            <span class="km-det" *ngIf="m.presentacion || m.cantidad || m.indicacion">{{m.presentacion}}<span *ngIf="m.cantidad"> · Cant. {{m.cantidad}}</span><span *ngIf="m.indicacion"> · {{m.indicacion}}</span></span>
                        </div>
                        <div class="kardex-meds-msg" *ngIf="h.medicamentos_cargados && (!h.medicamentos || h.medicamentos.length===0)">Sin medicamentos en esta historia.</div>
                    </div>
                    <div class="kardex-meta" *ngIf="h.importe || h.numero_documento_pago || h.observacion_cobro">
                        <span *ngIf="h.importe"><i class="fas fa-money-bill-alt"></i> {{h.importe}}</span>
                        <span *ngIf="h.numero_documento_pago"><i class="fas fa-receipt"></i> {{h.numero_documento_pago}}</span>
                        <span *ngIf="h.observacion_cobro" class="kardex-obscobro">{{h.observacion_cobro}}</span>
                    </div>
                    <div class="kardex-lab" *ngIf="usuario.empresa.usar_medicina_laboratorio && h.id_examen_laboratorio">
                        <span class="kardex-lab-badge"><i class="fas fa-vials"></i> Laboratorio</span>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- /receta-col-kardex -->

  </div><!-- /receta-layout -->
</div>
